<template>
  <div class="text-center">
    <v-dialog v-model="dialog" width="420">
      <template v-slot:activator="{ on, attrs }">
        <v-btn color="primary" x-small dark v-bind="attrs" v-on="on">
          <v-icon small>mdi-tune-variant</v-icon>
        </v-btn>
      </template>

      <v-card>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-card-title class="headline primary white--text">
            <span>{{ device.deviceName }}</span>
            <v-spacer></v-spacer>
            <v-icon dark>mdi-tune-variant</v-icon>
          </v-card-title>

          <v-card-text class="pt-8">
            <v-text-field
              v-model="deviceName"
              :rules="rules"
              label="Device Name"
              prepend-icon="mdi-tag"
              outlined
              color="accent"
            ></v-text-field>
            <v-checkbox
              class="mb-8"
              prepend-icon="mdi-alarm-snooze"
              hint="Sleep will be determined by battery. Ideal for Solar Devices."
              persistent-hint
              color="primary"
              v-model="newSettings.enabled"
              label="Automatic Sleep"
            ></v-checkbox>
            <v-text-field
              :disabled="newSettings.enabled"
              v-model="sleepSeconds"
              :rules="sleepRules"
              label="Device Sleep Seconds"
              prepend-icon="mdi-alarm-snooze"
              outlined
              color="accent"
              suffix="Seconds"
              type="number"
            ></v-text-field>
            <v-checkbox
              class="mb-8"
              prepend-icon="mdi-refresh"
              hint="If selected will delete and reset the stored Min/Max values."
              persistent-hint
              color="primary"
              v-model="resetMinMax"
              @change="setMinMax"
              label="Reset Min/Max Values"
            ></v-checkbox>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              :disabled="!valid"
              :loading="btnLoading"
              color="primary"
              class="mr-2"
              @click="save"
            >
              Save
            </v-btn>
            <v-btn color="primary" outlined @click="cancel">
              Cancel
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: ["device"],
  data() {
    return {
      dialog: false,
      rules: [(v) => !!v || "This field is required"],
      sleepRules: [
        (v) => (v && v >= 20) || "Sleep must be at least 20 seconds",
        (v) => (v && v <= 3600) || "Maximum sleep is 3600 seconds",
      ],
      valid: true,
      newSettings: {
        deviceName: null,
        sleepSeconds: null,
        resetMinMax: 0,
        enabled: false,
      },
    };
  },
  mounted() {
    this.newSettings = {
      deviceName: this.device.deviceName,
      sleepSeconds: this.device.sleepSeconds,
      ...(this.device.setSleepSeconds === 0
        ? { enabled: true }
        : { enabled: false }),
      resetMinMax: this.device.resetMinMax,
    };
  },
  computed: {
    ...mapState({
      btnLoading: (state) => state.btnLoading,
    }),

    deviceName: {
      get() {
        return this.device.deviceName;
      },
      set(newValue) {
        this.newSettings.deviceName = newValue;
      },
    },

    resetMinMax: {
      get() {
        return this.device.resetMinMax;
      },
      set(newValue) {
        this.newSettings.resetMinMax = newValue;
      },
    },

    sleepSeconds: {
      get() {
        return this.device.sleepSeconds;
      },
      set(newValue) {
        this.newSettings.sleepSeconds = newValue;
      },
    },
  },
  methods: {
    setMinMax(value) {
      if (value === true) {
        this.newSettings.resetMinMax = 1;
      } else {
        this.newSettings.resetMinMax = 0;
      }
    },

    save() {
      if (this.$refs.form.validate()) {
        const settings = {
          id: this.device.id,
          setDeviceName: this.newSettings.deviceName,
          ...(this.newSettings.enabled === true
            ? { setSleepSeconds: 0 }
            : { setSleepSeconds: Number(this.newSettings.sleepSeconds) }),
          resetMinMax: this.newSettings.resetMinMax,
        };
        console.log(settings);
        this.$store.dispatch("updateDevice", settings);
        this.cancel();
      }
    },

    reset() {
      this.editedItem = null;
    },

    cancel() {
      this.reset();
      this.dialog = false;
    },
  },
};
</script>
